import React from 'react'
import { Button, Box, IconButton, Typography } from '@material-ui/core'
import {
  GetApp as DownloadIcon,
  Fullscreen as FullscreenIcon,
  FullscreenExit as FullscreenExitIcon,
} from '@material-ui/icons'

const FlowchartHeader = ({
  title,
  description,
  isFullscreen,
  onToggleFullscreen,
  onDownloadPDF,
}) => {
  return (
    <Box mb={2} display="flex" justifyContent="space-between">
      <Box>
        <Typography variant="body1">{title}</Typography>
        <Typography variant="body2" color="textSecondary">
          {description}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center">
        <Box mr={1}>
          <IconButton
            onClick={onToggleFullscreen}
            title={isFullscreen ? 'Sair da tela cheia' : 'Tela cheia'}
          >
            {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
          </IconButton>
        </Box>
        <Button
          variant="contained"
          color="primary"
          startIcon={<DownloadIcon />}
          onClick={onDownloadPDF}
        >
          Baixar PDF
        </Button>
      </Box>
    </Box>
  )
}

export default FlowchartHeader
